import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useInsightsService } from '@/src/infrastructure/Protocol/Insights/useInsightsService';
import { IActivityUserCard } from '@/src/modules/InsightsModule/components/ActivityUser/components/CardActivity/CardActivity';

interface IActivityUserInsights {
  wac: IActivityUserCard | null;
  dac: IActivityUserCard | null;
  mac: IActivityUserCard | null;
}

const useActivityUserInsights = () => {
  const [data, setData] = useState<IActivityUserInsights>({
    wac: null,
    dac: null,
    mac: null,
  });
  const [loading, setLoading] = useState<boolean>(true);
  const service = useInsightsService();
  const haveData = useMemo(() => data.wac || data.dac || data.mac, [data]);
  const { t } = useTranslation(['insights']);
  const wordings = useMemo(() => {
    return {
      dailyActivity: {
        title: t('ACTIVITY_USER.DAC.title'),
        subtitle: t('ACTIVITY_USER.DAC.subtitle'),
        description: t('ACTIVITY_USER.DAC.description'),
        tooltip: t('ACTIVITY_USER.DAC.tooltip'),
        advance: t('ACTIVITY_USER.DAC.advance'),
      },
      weeklyActivity: {
        title: t('ACTIVITY_USER.WAC.title'),
        subtitle: t('ACTIVITY_USER.WAC.subtitle'),
        description: t('ACTIVITY_USER.WAC.description'),
        tooltip: t('ACTIVITY_USER.WAC.tooltip'),
        advance: t('ACTIVITY_USER.WAC.advance'),
      },
      monthlyActivity: {
        title: t('ACTIVITY_USER.MAC.title'),
        subtitle: t('ACTIVITY_USER.MAC.subtitle'),
        description: t('ACTIVITY_USER.MAC.description'),
        tooltip: t('ACTIVITY_USER.MAC.tooltip'),
        advance: t('ACTIVITY_USER.MAC.advance'),
      },
    };
  }, [t]);

  const getData = useCallback(async () => {
    setLoading(true);
    const data = await service.getInsightsActivityUser();
    if (data) {
      const result = data.map((item) => ({
        id: item.metricName,
        value: Number(item.activityPercentage),
      }));
      setData({
        dac: result.find((item) => item.id === 'dailyActivity') ?? null,
        wac: result.find((item) => item.id === 'weeklyActivity') ?? null,
        mac: result.find((item) => item.id === 'monthlyActivity') ?? null,
      });
    }
    setLoading(false);
  }, [service]);

  return {
    data,
    loading,
    getData,
    haveData,
    wordings,
  };
};

export default useActivityUserInsights;
